import React, { ChangeEvent, useContext } from 'react'

import { Card } from '@mui/material'
import Grid from '@mui/material/Grid'

import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import FormField from 'modules/FormField'

import { ExclusionForm } from '../../types'
import { ExclusionListFormContext } from '../constants'

function MainForm() {
	const { exclusionForm, setExclusionForm, setFormEdited, showError } =
		useContext(ExclusionListFormContext)

	const handleChange = (value: any, field: keyof ExclusionForm) => {
		setExclusionForm((prev: any) => ({
			...prev,
			[field]: value,
		}))
		setFormEdited(true)
	}
	return (
		<Card id="manage-exclusions">
			<MDBox p={2}>
				<Grid container spacing={3} alignItems="center">
					<Grid item xs={12}>
						<MDBox display="flex" justifyContent="space-between" alignItems="center">
							<MDBox display="flex" flexDirection="row" gap={2} alignItems="center">
								<MDTypography variant="h5" fontWeight="medium">
									Exclusion Number
								</MDTypography>
							</MDBox>
						</MDBox>
					</Grid>
					<Grid item xs={12} sm={6}>
						<MDBox display="flex" flexDirection="column" gap={1}>
							<MDTypography variant="h5" fontWeight="medium">
								Phone Number
							</MDTypography>

							<FormField
								type="tel"
								placeholder="+447912345678"
								value={exclusionForm.phone_number}
								onChange={(e: ChangeEvent<HTMLInputElement>) => {
									handleChange(e.target.value, 'phone_number')
								}}
								error={showError}
								helperText={showError && 'Please enter a valid UK phone number starting with +44'}
							/>
						</MDBox>
					</Grid>

					<Grid item xs={12} sm={6}>
						<MDBox display="flex" flexDirection="column" gap={1}>
							<MDTypography variant="h5" fontWeight="medium">
								Name
							</MDTypography>
							<FormField
								type="text"
								placeholder="e.g. Jane Doe"
								value={exclusionForm.name || ''}
								onChange={(e: ChangeEvent<HTMLInputElement>) =>
									handleChange(e.target.value, 'name')
								}
							/>
						</MDBox>
					</Grid>

					<Grid item xs={12}>
						<MDBox display="flex" flexDirection="column" gap={1}>
							<MDTypography variant="h5" fontWeight="medium">
								Notes
							</MDTypography>
							<FormField
								type="text"
								placeholder="e.g. Business Account"
								value={exclusionForm.notes || ''}
								onChange={(e: ChangeEvent<HTMLInputElement>) =>
									handleChange(e.target.value, 'notes')
								}
							/>
						</MDBox>
					</Grid>
				</Grid>
			</MDBox>
		</Card>
	)
}

export default MainForm
